import jwtDecode from 'jwt-decode';
import TokenStorage from '../../storages/token-storage'

import { subscriptionTypes, subscribe } from './actions'


const _initalState = {
    isFetching: false,
    error: null,
    data: {
        customer: null,
        subscription: null,
    },
    tempToken: null,
    tokenStatus: 'initial',
    // Subscription Contracts V2 / embedded checkout
    checkoutSession: {
        isFetching: false,
        token: null,
        currency: null,
        colorScheme: null,
        expiresAt: null,
        error: null,
    },
    checkoutCompleted: false,
    contract: {
        isFetching: false,
        data: null,
        live: null,
        paymentMethods: [],
        billingRuns: [],
        // Other billing intervals the contract can be switched to
        planOptions: [],
        error: null,
    },
}

export function subscription(state=_initalState, action) {
    switch (action.type) {


        case subscriptionTypes.REQUEST:
            state = {
                ...state,
                isFetching: true,
                error: null
            }
            return state

        case subscriptionTypes.ERROR_TOKEN_STATUS:
        case subscriptionTypes.ERROR_TEMP_TOKEN:
        case subscriptionTypes.ERROR:
            state = {
                ...state,
                isFetching: false,
                error: action.data.message
            }
            return state
        case subscriptionTypes.RECEIVE:
            state = {
                ...state,
                error: null,
                isFetching: false, 
                data: action.data.response
            }
            return state

        case subscriptionTypes.RECEIVE_TEMP_TOKEN:
            state = {
                ...state,
                error: null,
                isFetching: false, 
                tempToken: action.data.token,
                cardVerificationUrl: action.data.card_verification_url
            }
            return state

        case subscriptionTypes.RECEIVE_TOKEN_STATUS:
            state = {
                ...state,
                tokenStatus: action.data.status
            }
            return state

        case subscriptionTypes.REQUEST_CHECKOUT_SESSION:
            return {
                ...state,
                checkoutCompleted: false,
                checkoutSession: { ...state.checkoutSession, isFetching: true, token: null, error: null },
            }

        case subscriptionTypes.RECEIVE_CHECKOUT_SESSION:
            return {
                ...state,
                checkoutSession: {
                    isFetching: false,
                    token: action.data.token,
                    currency: action.data.currency,
                    colorScheme: action.data.color_scheme,
                    expiresAt: action.data.expires_at,
                    error: null,
                },
            }

        case subscriptionTypes.ERROR_CHECKOUT_SESSION:
            return {
                ...state,
                checkoutSession: { ...state.checkoutSession, isFetching: false, token: null, error: action.data.message },
            }

        case subscriptionTypes.CHECKOUT_COMPLETED:
            return {
                ...state,
                checkoutCompleted: true,
                checkoutSession: { ...state.checkoutSession, token: null },
            }

        case subscriptionTypes.REQUEST_CONTRACT:
            return {
                ...state,
                contract: { ...state.contract, isFetching: true, error: null },
            }

        case subscriptionTypes.RECEIVE_CONTRACT:
            return {
                ...state,
                contract: {
                    isFetching: false,
                    data: action.data.contract || null,
                    // Responses that did not look these up send null; keep what we have then
                    live: action.data.live || state.contract.live,
                    paymentMethods: action.data.payment_methods || state.contract.paymentMethods,
                    billingRuns: action.data.billing_runs || state.contract.billingRuns,
                    planOptions: action.data.plan_options || state.contract.planOptions,
                    error: null,
                },
            }

        case subscriptionTypes.ERROR_CONTRACT:
            return {
                ...state,
                contract: { ...state.contract, isFetching: false, error: action.data.message },
            }
    
        default:
            return state
    }
}